import { render, staticRenderFns } from "./myPartnerInvoice.vue?vue&type=template&id=b359313e"
import script from "./myPartnerInvoice.vue?vue&type=script&lang=js"
export * from "./myPartnerInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports